import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HandsWash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 576 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M496 224a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-184.53-45.55A56.77 56.77 0 0 1 328 176a56 56 0 0 1 19 3.49l15.35-48.61A24 24 0 0 0 342 99.74c-11.53-1.35-22.21 6.44-25.71 17.51l-20.9 66.17zM93.65 386.33c.8-.19 1.54-.54 2.35-.71v-25.69a156 156 0 0 1 107.06-148l73.7-22.76 34.16-108.12a24 24 0 0 0-20.33-31.11c-11.53-1.34-22.22 6.45-25.72 17.52l-33.45 106.42a8 8 0 0 1-15.26-4.83l43.37-137.79A24 24 0 0 0 239.2.15C227.67-1.19 217 6.6 213.49 17.66l-47.93 151.71a8 8 0 1 1-15.26-4.82l38.56-122a24 24 0 0 0-20.33-31.11C157 10 146.32 17.83 142.82 28.9l-60 189.85-2.06-50.05a24 24 0 0 0-23.86-24.15c-13.23-.05-24.72 10.54-24.9 23.86v112.73a123.69 123.69 0 0 0 61.65 105.19zM519.1 336H360a8 8 0 0 1 0-16h128a24 24 0 0 0 23.54-28.76c-2.19-11.4-12.83-19.24-24.44-19.24H288l47.09-17.06a24 24 0 0 0-14.18-45.88l-107.72 33.25A123.88 123.88 0 0 0 128 360v25.65a79.78 79.78 0 0 1 58 108.63A118.9 118.9 0 0 0 248 512h208a24 24 0 0 0 23.54-28.76c-2.19-11.4-12.83-19.24-24.44-19.24H360a8 8 0 0 1 0-16h128a24 24 0 0 0 23.54-28.76c-2.19-11.4-12.83-19.24-24.44-19.24H360a8 8 0 0 1 0-16h160a24 24 0 0 0 23.54-28.76c-2.19-11.4-12.83-19.24-24.44-19.24zM416 64a32 32 0 1 0-32-32 32 32 0 0 0 32 32zM112 416a48 48 0 1 0 48 48 48 48 0 0 0-48-48z"
  }));
});
HandsWash.displayName = 'HandsWash';
export var HandsWashDimensions = {
  height: 512,
  width: 576
};